"use client";
import { NavToggle } from "@zapier/shared";
import { usePathname } from "next/navigation";

export function FolderZapToggle() {
  const pathname = usePathname();

  // Normalize folders path - both /app/assets/folders and /app/assets/zaps/folders
  // should be treated as the folders view
  const normalizedPath =
    pathname === "/app/assets/folders" ? "/app/assets/zaps/folders" : pathname;

  const links = [
    {
      id: "zap-filter-toggle",
      label: "Zap workflows",
      icon: "miscBoltAlt",
      href: "/app/assets/zaps",
    },
    {
      id: "folder-filter-toggle",
      label: "Folders",
      icon: "navFolder",
      href: "/app/assets/zaps/folders",
    },
  ];

  return <NavToggle links={links} currentPath={normalizedPath || ""} />;
}
